import { DiscoveryPlaylistResponseState } from './types';

export const discoveryPlaylistInitialState: DiscoveryPlaylistResponseState = {
  loading: true,
  error: false,
  data: [],
  position: {
    lastCoverPostion: '',
  },
};
